import ProjectLink from "@/components/UI-copmonents/ProjectLink";

export default [ProjectLink];
